const type = "production" // production | staging | local

let apiServiceUrl, storageServiceUrl, socketServiceUrl;
const apiServiceUrlVersion = "v1";

switch (type) {
    case "production":
        apiServiceUrl = "https://api-sikap-idaman.kukarkab.go.id";
        storageServiceUrl = "https://storage-sikap-idaman.kukarkab.go.id";
        socketServiceUrl = "https://socket-sikap-idaman.kukarkab.go.id";
        
        break;
    case "staging":
        apiServiceUrl = "https://api-sipekad.kukarkab.go.id";
        storageServiceUrl = "https://storage-sipekad.kukarkab.go.id";
        socketServiceUrl = "https://socket-sipekad.kukarkab.go.id";
        
        break;
    case "local":
        apiServiceUrl = "http://localhost:3002";
        storageServiceUrl = "http://localhost:3000";
        socketServiceUrl = "http://localhost:3003";
        
        break;
}

export const apiServiceBaseUrl = `${apiServiceUrl}/${apiServiceUrlVersion}`
export const storageServiceBaseUrl = `${storageServiceUrl}`
export const socketServiceBaseUrl = `${socketServiceUrl}`
export const tataNaskahServiceUrl = "https://tata-naskah.enova.co.id/api";